import { userContextSlice } from '@tdp/common/auth';
import { detectHost } from '@tdp/common/host/hostDetection';
import { settingsSlice } from '@tdp/common/settings';
import { PromisedReturnType } from '@tdp/common/shared/tsUtils';

import { composeRoutes } from './routes';
import { composeServices } from './services';
import { composeStore, DevPortalCommands } from './store';
import { BuildConfig } from './util/buildConfig';
import { createShimObject } from './util/shim';

export async function compositionRoot(envConfig: BuildConfig) {
  const services = await composeServices(envConfig);
  // unravel the circular dependency between commands & routes using this shim object
  const [commandsShim, setCommandsShim] = createShimObject<DevPortalCommands>();
  const { router } = await composeRoutes({ commands: commandsShim });
  const { store, commands } = await composeStore({ services, router });
  setCommandsShim(commands);

  // Uncomment to set the locale to the debug locale
  //store.dispatch(commands.localeCommands.updateCurrentLocale('en-dbg'));

  return { store, services, router, commands };
}

export type DevPortalRoot = PromisedReturnType<typeof compositionRoot>;
